import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@service/auth.service';
import { ContactService } from '@service/contact.service';
import { MimicsService } from '@service/mimics.service';

@Component({
    selector: 'app-save-mimic-dialog',
    templateUrl: './save-mimic-dialog.component.html',
    styleUrl: './save-mimic-dialog.component.scss',
    standalone: false,
})
export class SaveMimicDialogComponent implements OnInit {
    intervalError;
    displaySlowText: boolean = false;
    hasErrorSave: boolean = false;
    isSaving: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            selectedMimic;
        },
        private dialogRef: MatDialogRef<SaveMimicDialogComponent>,
        private mimicService: MimicsService,
        private authService: AuthService,
        private contactService: ContactService
    ) {}

    ngOnInit() {
        if (!this.data?.selectedMimic) return;
        this.startMimicSave();
    }

    async startMimicSave() {
        try {
            this.isSaving = true;
            this.startInterval();
            await this.mimicService.update(this.data.selectedMimic);
            this.dialogRef.close(true);
        } catch (err) {
            this.isSaving = false;
            this.hasErrorSave = true;
            if (this.intervalError) {
                clearInterval(this.intervalError);
                this.intervalError = null;
            }
        }
    }

    startInterval() {
        if (this.intervalError) {
            clearInterval(this.intervalError);
            this.intervalError = null;
        }
        this.intervalError = setInterval(() => {
            this.displaySlowText = true;
        }, 30000);
    }

    cancel() {
        if (this.intervalError) {
            clearInterval(this.intervalError);
            this.intervalError = null;
        }
        this.dialogRef.close(false);
    }

    async report() {
        if (this.intervalError) {
            clearInterval(this.intervalError);
            this.intervalError = null;
        }
        try {
            const receiverAddress = this.authService.getCurrentUser().email;
            await this.contactService.sendErrorReport(receiverAddress);
        } catch (err) {
            console.error(err);
        } finally {
            this.dialogRef.close(false);
        }
    }
}
